import { useNavigate } from 'react-router-dom';

const options = [
  { label: '25分钟', value: 25 },
  { label: '15分钟', value: 15 },
  { label: '自定义', value: 0 },
];

interface QuickFocusProps {
  selected: number;
  onSelect: (v: number) => void;
}

export default function QuickFocus({ selected, onSelect }: QuickFocusProps) {
  const navigate = useNavigate();

  const handleClick = (value: number) => {
    onSelect(value);
    navigate('/focus');
  };

  return (
    <div className="px-4 mb-4">
      <p className="font-semibold text-sm mb-2" style={{ color: '#3D3D3D' }}>快速专注</p>
      <div className="flex gap-2">
        {options.map(opt => {
          const isActive = selected === opt.value;
          return (
            <button
              key={opt.value}
              onClick={() => handleClick(opt.value)}
              className="flex-1 py-2.5 rounded-xl text-sm font-medium transition-all active:scale-95 cursor-pointer whitespace-nowrap"
              style={{
                background: isActive
                  ? 'linear-gradient(135deg,#B5C6E0,#C5B9D8)'
                  : 'rgba(255,255,255,0.72)',
                color: isActive ? '#fff' : '#8E8E93',
                border: isActive ? 'none' : '1px solid rgba(181,198,224,0.3)',
                backdropFilter: 'blur(8px)',
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
